import Lenis from '@studio-freight/lenis'
import { EVENT } from '../constant';
import Emitter from './Emitter';

export default class SmoothScroll {
    constructor() {
        const lenis = new Lenis({
            lerp: 0.06,
            smooth: true,
            direction: 'vertical',
        })

        this.instance = lenis;

        this.instance.on('scroll', (scrollOpt) => {
            Emitter.emit(EVENT.SCROLL, scrollOpt)
        })

        const scrollFn = () => {
            lenis.raf();
            requestAnimationFrame(scrollFn);
        };

        requestAnimationFrame(scrollFn);
    }
}